import React from 'react';

const App = () => {
  return <div>Catering App Here</div>;
};

export default App;
